import React, { useEffect, useState } from "react";
import _ from "lodash";
import { useSelector } from "react-redux";
import { getProgressReportStatus } from "../../../core/service/progressReport.service";

import { styled } from "@mui/material/styles";
import { Card, Stack, Stepper, Step, StepLabel, Box } from "@mui/material";

import CheckIcon from "@mui/icons-material/Check";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import CloseIcon from "@mui/icons-material/Close";
import PendingActionsIcon from "@mui/icons-material/PendingActions";

import StepConnector, {
  stepConnectorClasses
} from "@mui/material/StepConnector";

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22
  },
  // [`&.${stepConnectorClasses.active}`]: {
  //   [`& .${stepConnectorClasses.line}`]: {
  //     backgroundImage: "linear-gradient(#eaeaf0,#eaeaf0)"
  //   }
  // },
  // [`&.${stepConnectorClasses.completed}`]: {
  //   [`& .${stepConnectorClasses.line}`]: {
  //     backgroundImage: "linear-gradient(#1CD1A1,#1CD1A1)"
  //   }
  // },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor:
      theme.palette.mode === "dark" ? theme.palette.grey[800] : "#eaeaf0",
    borderRadius: 1
  }
}));

const ColorlibStepIconRoot = styled("div")(({ theme, ownerState }) => {
  const { choose } = ownerState;

  return {
    backgroundColor:
      theme.palette.mode === "dark" ? theme.palette.grey[700] : "#ccc",
    zIndex: 1,
    color: "#fff",
    width: 50,
    height: 50,
    display: "flex",
    borderRadius: "50%",
    justifyContent: "center",
    alignItems: "center",
    ...(choose?.type?.type.render.displayName === "CheckIcon"
      ? { backgroundImage: "linear-gradient(#1CD1A1,#1CD1A1)" }
      : choose?.type?.type.render.displayName === "CloseIcon"
      ? {
          backgroundImage: "linear-gradient(#FF0000,#FF0000)"
        }
      : choose?.type?.type.render.displayName === "CheckOutlinedIcon" && {
          backgroundImage: "linear-gradient(#FF7A00,#FF7A00)"
        })
  };
});

const choose1 = "6 months progress report";
const choose2 = "11 months progress report with requesting extension period";
const choose3 = "11 months progress report (Final report)";
const choose4 =
  "Progress report for every 3 or 6 month after requesting extension period";
const choose5 = "Final Progress Report (Before or After 11 months)";

export default function StepperPostdoc() {
  const { user: currentUser } = useSelector((state) => state.authReducer);
  const { id } = currentUser;
  const { user: anotherUser, isClickAnotherProfile } = useSelector(
    (state) => state.userProfileReducer
  );
  const [statusProgressReport, setStatusProgressReport] = useState([]);

  const getStatusProgressReport = async (id) => {
    const data = await getProgressReportStatus(id);
    setStatusProgressReport(data?.entities);
  };

  const getStatusProgressReportByUser = async (id) => {
    const data = await getProgressReportStatus(id);
    setStatusProgressReport(data?.entities);
  };

  useEffect(() => {
    if (isClickAnotherProfile) {
      if (anotherUser) getStatusProgressReportByUser(anotherUser?.id);
    } else getStatusProgressReport(id);
  }, []);

  const steps6M_ab = [
    "Progress Report 6 M",
    "Progress Report 11 M",
    "Paper Accepted or Published"
  ];
  const steps6M_cd = [
    "Progress Report 6 M",
    "Progress Report 11 M",
    "Paper Accepted or Published"
  ];
  const steps11M_extent = [
    "Progress Report 6 M",
    "Progress Report 11 M",
    "Paper Accepted or Published",
    "Extension of research",
    "Paper Accepted or Published"
  ];
  const steps11M_final = [
    "Progress Report 6 M",
    "Progress Report 11 M",
    "Paper Accepted or Published"
  ];
  const stepsAT_extent_3m_6m = [
    "Progress Report 6 M",
    "Progress Report 11 M",
    "Paper Accepted or Published",
    "Extension of research",
    "Paper Accepted or Published"
  ];
  const stepsFinal_bf_at_11m = [
    "Progress Report 6 M",
    "Progress Report 11 M",
    "Paper Accepted or Published"
  ];

  const checkProgress = [
    ...new Set(
      statusProgressReport?.reduce((acc, e) => {
        acc.push(e?.report_for);
        return acc;
      }, [])
    )
  ];

  const formatBeforeActive = (choose = []) => {
    const pass = choose?.filter((e) => e.choose === 1).length;
    const notPass = choose?.filter((e) => e.choose === 2).length;
    const pending = choose?.filter((e) => e.choose === 0).length;

    switch (true) {
      case pending !== 0:
        return 0;
      case pass !== 0 && pending === 0:
        return 1;
      case notPass !== 0 && pending === 0:
        return 2;
      default:
        return undefined;
    }
  };

  const progressChoose = (statusProgressReport = []) => {
    let progressChoose1AB = statusProgressReport
      .filter(
        (e) =>
          e.report_for === choose1 &&
          (e.form_nm === "section_a" || e.form_nm === "section_b")
      )
      .map((e) => ({
        choose:
          (e.mentor_approve === 1 && e.admin_approve === 3) ||
          e.admin_approve === 1
            ? 1
            : (e.mentor_approve === 2 && e.admin_approve === 3) ||
              e.admin_approve === 2
            ? 2
            : 0
      }));
    let progressChoose1CD = statusProgressReport
      .filter(
        (e) =>
          e.report_for === choose1 &&
          (e.form_nm === "section_c" || e.form_nm === "section_d")
      )
      .map((e) => ({
        choose:
          (e.mentor_approve === 1 && e.admin_approve === 3) ||
          e.admin_approve === 1
            ? 1
            : (e.mentor_approve === 2 && e.admin_approve === 3) ||
              e.admin_approve === 2
            ? 2
            : 0
      }));
    let progressChoose2 = statusProgressReport
      .filter((e) => e.report_for === choose2)
      .map((e) => ({
        choose:
          (e.mentor_approve === 1 && e.admin_approve === 3) ||
          e.admin_approve === 1
            ? 1
            : (e.mentor_approve === 2 && e.admin_approve === 3) ||
              e.admin_approve === 2
            ? 2
            : 0
      }));
    let progressChoose3 = statusProgressReport
      .filter((e) => e.report_for === choose3)
      .map((e) => ({
        choose:
          (e.mentor_approve === 1 && e.admin_approve === 3) ||
          e.admin_approve === 1
            ? 1
            : (e.mentor_approve === 2 && e.admin_approve === 3) ||
              e.admin_approve === 2
            ? 2
            : 0
      }));
    let progressChoose4 = statusProgressReport
      .filter((e) => e.report_for === choose4)
      .map((e) => ({
        choose:
          (e.mentor_approve === 1 && e.admin_approve === 3) ||
          e.admin_approve === 1
            ? 1
            : (e.mentor_approve === 2 && e.admin_approve === 3) ||
              e.admin_approve === 2
            ? 2
            : 0
      }));
    let progressChoose5 = statusProgressReport
      .filter((e) => e.report_for === choose5)
      .map((e) => ({
        choose:
          (e.mentor_approve === 1 && e.admin_approve === 3) ||
          e.admin_approve === 1
            ? 1
            : (e.mentor_approve === 2 && e.admin_approve === 3) ||
              e.admin_approve === 2
            ? 2
            : 0
      }));

    progressChoose1AB = formatBeforeActive(progressChoose1AB);
    progressChoose1CD = formatBeforeActive(progressChoose1CD);
    progressChoose2 = formatBeforeActive(progressChoose2);
    progressChoose3 = formatBeforeActive(progressChoose3);
    progressChoose4 = formatBeforeActive(progressChoose4);
    progressChoose5 = formatBeforeActive(progressChoose5);

    return {
      progressChoose1AB,
      progressChoose1CD,
      progressChoose2,
      progressChoose3,
      progressChoose4,
      progressChoose5
    };
  };

  const ColorlibStepIconChoose1 = (props) => {
    const { className, icon } = props;
    let choose = {};
    let icons = {};

    if (statusProgressReport.length !== 0)
      choose = progressChoose(statusProgressReport);

    if (choose.progressChoose1AB !== undefined) {
      if (choose.progressChoose1CD !== undefined) {
        icons = {
          1:
            choose.progressChoose1AB !== undefined &&
            (choose.progressChoose1AB === 1 ? (
              <CheckIcon />
            ) : choose.progressChoose1AB === 2 ? (
              <CloseIcon />
            ) : (
              <PendingActionsIcon />
            )),
          2: <CheckOutlinedIcon />,
          3:
            choose.progressChoose1CD !== undefined &&
            (choose.progressChoose1CD === 1 ? (
              <CheckIcon />
            ) : choose.progressChoose1CD === 2 ? (
              <CloseIcon />
            ) : (
              <PendingActionsIcon />
            ))
        };
      } else {
        icons = {
          1:
            choose.progressChoose1AB !== undefined &&
            (choose.progressChoose1AB === 1 ? (
              <CheckIcon />
            ) : choose.progressChoose1AB === 2 ? (
              <CloseIcon />
            ) : (
              <PendingActionsIcon />
            )),
          2: null,
          3: null
        };
      }
    }

    return (
      <ColorlibStepIconRoot
        ownerState={{ icon, choose: icons[String(icon)] }}
        className={className}
      >
        {icons[String(icon)]}
      </ColorlibStepIconRoot>
    );
  };

  const ColorlibStepIconChoose2 = (props) => {
    const { className, icon } = props;
    let choose = {};

    if (statusProgressReport.length !== 0)
      choose = progressChoose(statusProgressReport);

    const icons = {
      1: <CheckIcon />,
      2:
        choose.progressChoose2 !== undefined &&
        (choose.progressChoose2 === 1 ? (
          <CheckIcon />
        ) : choose.progressChoose2 === 2 ? (
          <CloseIcon />
        ) : (
          <PendingActionsIcon />
        )),
      3: <CheckOutlinedIcon />,
      4: null,
      5: null
    };

    return (
      <ColorlibStepIconRoot
        ownerState={{ icon, choose: icons[String(icon)] }}
        className={className}
      >
        {icons[String(icon)]}
      </ColorlibStepIconRoot>
    );
  };

  const ColorlibStepIconChoose3 = (props) => {
    const { className, icon } = props;
    let choose = {};

    if (statusProgressReport.length !== 0)
      choose = progressChoose(statusProgressReport);

    const icons = {
      1: <CheckIcon />,
      2:
        choose.progressChoose3 !== undefined &&
        (choose.progressChoose3 === 1 ? (
          <CheckIcon />
        ) : choose.progressChoose3 === 2 ? (
          <CloseIcon />
        ) : (
          <PendingActionsIcon />
        )),
      3:
        choose.progressChoose3 !== undefined &&
        (choose.progressChoose3 === 1 ? (
          <CheckIcon />
        ) : choose.progressChoose3 === 2 ? (
          <CloseIcon />
        ) : (
          <PendingActionsIcon />
        ))
    };

    return (
      <ColorlibStepIconRoot
        ownerState={{ icon, choose: icons[String(icon)] }}
        className={className}
      >
        {icons[String(icon)]}
      </ColorlibStepIconRoot>
    );
  };

  const ColorlibStepIconChoose4 = (props) => {
    const { className, icon } = props;
    let choose = {};

    if (statusProgressReport.length !== 0)
      choose = progressChoose(statusProgressReport);

    const icons = {
      1: <CheckIcon />,
      2: <CheckIcon />,
      3: <CheckOutlinedIcon />,
      4:
        choose.progressChoose4 !== undefined &&
        (choose.progressChoose4 === 1 ? (
          <CheckIcon />
        ) : choose.progressChoose4 === 2 ? (
          <CloseIcon />
        ) : (
          <PendingActionsIcon />
        )),
      5: null
    };

    return (
      <ColorlibStepIconRoot
        ownerState={{ icon, choose: icons[String(icon)] }}
        className={className}
      >
        {icons[String(icon)]}
      </ColorlibStepIconRoot>
    );
  };

  const ColorlibStepIconChoose5 = (props) => {
    const { className, icon } = props;
    let choose = {};

    if (statusProgressReport.length !== 0)
      choose = progressChoose(statusProgressReport);

    const icons = {
      1:
        choose.progressChoose5 !== undefined &&
        (choose.progressChoose5 === 1 ? (
          <CheckIcon />
        ) : choose.progressChoose5 === 2 ? (
          <CloseIcon />
        ) : (
          <PendingActionsIcon />
        )),
      2:
        choose.progressChoose5 !== undefined &&
        (choose.progressChoose5 === 1 ? (
          <CheckIcon />
        ) : choose.progressChoose5 === 2 ? (
          <CloseIcon />
        ) : (
          <PendingActionsIcon />
        )),
      3:
        choose.progressChoose5 !== undefined &&
        (choose.progressChoose5 === 1 ? (
          <CheckIcon />
        ) : choose.progressChoose5 === 2 ? (
          <CloseIcon />
        ) : (
          <PendingActionsIcon />
        ))
    };

    return (
      <ColorlibStepIconRoot
        ownerState={{ icon, choose: icons[String(icon)] }}
        className={className}
      >
        {icons[String(icon)]}
      </ColorlibStepIconRoot>
    );
  };

  return (
    <Card>
      <Box sx={{ p: 3, pb: 1, paddingTop: 5 }} dir="ltr">
        <Stack sx={{ width: "100%" }} spacing={4}>
          <Stepper
            alternativeLabel
            connector={<ColorlibConnector />}
            sx={{ paddingBottom: 3 }}
          >
            {(checkProgress?.some(
              (e) =>
                e === choose1 &&
                (e.form_nm === "section_a" || e.form_nm === "section_b")
            )
              ? steps6M_ab
              : steps6M_cd
            ).map((label, index) => (
              <Step key={index}>
                <StepLabel StepIconComponent={ColorlibStepIconChoose1}>
                  {label}
                </StepLabel>
              </Step>
            ))}
          </Stepper>

          {checkProgress?.some((e) => e === choose2) && (
            <Stepper
              alternativeLabel
              connector={<ColorlibConnector />}
              sx={{ paddingBottom: 3 }}
            >
              {steps11M_extent.map((label, index) => (
                <Step key={index}>
                  <StepLabel StepIconComponent={ColorlibStepIconChoose2}>
                    {label}
                  </StepLabel>
                </Step>
              ))}
            </Stepper>
          )}

          {checkProgress?.some((e) => e === choose3) && (
            <Stepper
              alternativeLabel
              connector={<ColorlibConnector />}
              sx={{ paddingBottom: 3 }}
            >
              {steps11M_final.map((label, index) => (
                <Step key={index}>
                  <StepLabel StepIconComponent={ColorlibStepIconChoose3}>
                    {label}
                  </StepLabel>
                </Step>
              ))}
            </Stepper>
          )}

          {checkProgress?.some((e) => e === choose4) && (
            <Stepper
              alternativeLabel
              connector={<ColorlibConnector />}
              sx={{ paddingBottom: 3 }}
            >
              {stepsAT_extent_3m_6m.map((label, index) => (
                <Step key={index}>
                  <StepLabel StepIconComponent={ColorlibStepIconChoose4}>
                    {label}
                  </StepLabel>
                </Step>
              ))}
            </Stepper>
          )}

          {checkProgress?.some((e) => e === choose5) && (
            <Stepper
              alternativeLabel
              connector={<ColorlibConnector />}
              sx={{ paddingBottom: 3 }}
            >
              {stepsFinal_bf_at_11m.map((label, index) => (
                <Step key={index}>
                  <StepLabel StepIconComponent={ColorlibStepIconChoose5}>
                    {label}
                  </StepLabel>
                </Step>
              ))}
            </Stepper>
          )}
        </Stack>
      </Box>
    </Card>
  );
}
